module.exports = __webpack_public_path__ + "img/GeorgeKipiani.893f8e42.webp";